import React, { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import selectors from 'state/selectors';
import actions from 'state/actions';
import { headerHeight, toogleHeight } from 'utils/styleConstants';
import ArrowLeft from 'images/arrow';
import utils from 'utils';

const SidebarWrapper = styled.aside<{ isOpen: boolean }>`
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  border-right: solid 1px ${({ theme }) => theme.colorPalette.grey.grey5};
  position: fixed;
  top: ${headerHeight}px;
  left: 0;
  width: ${({ isOpen }) => (isOpen ? '284px' : '64px')};
  height: calc(100vh - ${headerHeight}px);
  transition: width 0.3s ease;
  overflow: hidden;
  z-index: ${({ theme }) => theme.zIndexPalette.medium};
  display: flex;
  flex-direction: column;
`;

const ToggleBar = styled.div<{ isOpen: boolean }>`
  height: ${toogleHeight}px;
  min-width: 60px;
  line-height: ${toogleHeight}px;
  background-color: ${({ theme: { colorPalette } }) =>
    colorPalette.isDarkMode ? colorPalette.turquoise.accent3 : colorPalette.turquoise.background};
  color: ${({ theme: { colorPalette } }) => colorPalette.isDarkMode ? colorPalette.turquoise.accent : colorPalette.turquoise.dark};

  text-align: right;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily};

  display: flex;
  justify-content: ${({ isOpen }) => isOpen ? 'flex-start' : 'center'};
  gap: 10px;
  padding-left: ${({ isOpen }) => isOpen ? '10px' : ''};
  align-items: center;
  svg {
    width: 20px;
    height: 20px;
  }
`;



const ContentWrapper = styled.div<{ isOpen: boolean }>`
  transition: all 0.3s ease;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left:8px;
`;
const Label = styled.span`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
`;


interface SidebarProps {
  children: ReactNode;
  onToggle?: () => void;
  isOpen?: boolean;
  onSearch?: (query: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ children, onToggle, isOpen: isOpenProp }) => {
  const t = utils.intl.useTranslator();
  const isOpen = isOpenProp ?? useSelector(selectors.app.getMenu);
  const dispatch = useDispatch();

  const handleToggle = () => {
    if (onToggle) {
      onToggle();
    } else {
      dispatch(actions.app.toggleMenu());
    }
  };


  return (
    <SidebarWrapper isOpen={isOpen}>
      <ToggleBar isOpen={isOpen} onClick={handleToggle}> 
        {isOpen ? <Content><ArrowLeft /> <Label>{t('closeSidebar')}</Label></Content> : <ArrowLeft rotation={180} />}
      </ToggleBar>
      <ContentWrapper isOpen={isOpen}>{children}</ContentWrapper>
    </SidebarWrapper>
  );
};

export default Sidebar;
